// const path = "/v2/organization/writer";
/**
 * @typedef {Object} CourseObject
 * @property {String} _id
 */

/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  const path = `/v2/organization/`;
  return {
    /**
     *
     * @param {Object} param0
     * @param {String} param0.target
     * @returns {CourseObject}
     */
    async clone({ target } = {}) {
      const results = await repository.post(`${path}writer/course/copy`, {
        course: target
      });
      return results.data.object;
    },

    /**
     *
     * @param {String} param0.id ID of the course
     * @returns {Promise<Array<Course>>}
     */
    getOne({ id, type } = {}) {
      return repository
        .get(`${path}${type}/course`, {
          params: {
            id: id
          }
        })
        .then(response => {
          // console.log(response);
          return Promise.resolve(response.data.object);
        });
      //catch is handled by parents
    },
    /**
     * @typedef {Object} Options
     * @property {String} type default notpublished, can be notpublished, published
     * @param {Options} param0
     */
    /**
     *
     * @param {Object} param0
     * @param {String} param0.status default notpublished, can be notpublished, published
     * @param {String} param0.type Publisher
     * @returns {Array}
     */
    get({ status, type } = { status: "notpublished" }) {
      return repository
        .get(`${path}${type}/course`, { params: { type: status } })
        .then(response => {
          return Promise.resolve(response.data.object);
        });
    },
    /**
     * Creates a new draft for the current writer. Returns a new course object
     * @typedef {Object} Course
     * @property {String} name
     * @property {String} category
     * @property {Number} duration
     *
     * @param {Course} param0.coursedoc Must have name, duration, category
     * @returns A course object
     */
    create({ coursedoc, type } = {}) {
      // console.log(coursedoc);
      return repository.post(`${path}${type}/course`, {
        ...coursedoc,
        duration: 1
      });
    },
    /**
     *
     * @param {String} param0.id ID of the coruse to update
     * @param {Object} param0.coursedoc Document to update
     * @return A course object
     */
    update({ id, coursedoc, type } = {}) {
      return repository.put(`${path}${type}/course?id=${id}`, coursedoc);
    },
    /**
     *
     * @param {String} param0.id
     */
    delete({ id, type } = {}) {
      return repository.delete(`${path}${type}/course?id=${id}`);
    },
    /**
     *
     * @param {Object} param0
     * @param {String} param0.id ID of course to publish
     */
    publish({ id } = {}) {
      return repository.post(`${path}/self/publish?id=${encodeURI(id)}`);
    }
  };
}
